const logError = (message: string): void => {
  console.error('logError', message);
};

export default logError;
